<span class="inline-flex h-5 items-center rounded-full bg-primary-100 px-2 text-[10px] font-semibold uppercase text-primary-700">Required</span>
